import { useLoggedInUser } from '@tcc/shared-data-lib';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useUserLoggedInConfigs } from '../utils/sharedData';
import { reportError } from '../utils/datadog';
import {
  getIsGlanceFeatureFlagEnable,
  initializeGlance,
} from '../utils/glance';

// Cobrowsing is a feature that allows user to share their browser screen with the
// support teams, so they can triage problems. It is turn it on on-demand via feature flag.
export const useCobrowsingSupport = () => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const [isLoading, setIsLoading] = useState(false);
  const isMounted = useRef(true);

  const boot = useCallback(async () => {
    if (!user) return;

    const storageKey = `field-view-cobrowsing-initialized:${String(user.id)}`;
    if (window.sessionStorage.getItem(storageKey) === 'true') return;

    window.sessionStorage.setItem(storageKey, 'true');
    
    try {
      const isGlanceEnable = await getIsGlanceFeatureFlagEnable(user.id);
      if (isGlanceEnable) initializeGlance(user.id);

      if (isMounted.current) {
        setIsLoading(true);
      }
    } catch (error) {
      reportError('FieldViewCobrowsingInitError', error, {
        hook: 'useCobrowsingSupport',
        userId: String(user.id),
      });
    }
  }, [user]);

  useEffect(() => {
    isMounted.current = true;
    boot();

    return () => {
      isMounted.current = false;
    };
  }, [boot]);

  return { isLoading };
};
